import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IAllLeadsResponse, ILead } from "../models/Lead";

export default function useEmails() {
  const { get, post, put } = useApiHelper();
  const queryClient = useQueryClient();

  const sendEmail = useMutation(
    (email : any) => post(`/email`, email),
    {
      onSuccess: () => {
      },
    }
  );

  const sendDocumentsEmail = useMutation(
    (email : any) => post(`/email/documents`, email),
    {
      onSuccess: () => {
      },
    }
  );

  const BulkSendDocumentsEmails = useMutation(
    (body : any) => post(`/email/bulk/documents/both`, body),
    {
      onSuccess: () => {
      },
    }
  );

  const BulkSendDocumentRequestEmails = useMutation(
    (body : any) => post(`/email/bulk/documents/request`, body),
    {
      onSuccess: () => {
      },
    }
  );

  const BulkSendBookingConfirmationEmails = useMutation(
    (body : any) => post(`/email/bulk/booking/confirmation`, body),
    {
      onSuccess: () => {
      },
    }
  );

  return {
    sendEmail,
    sendDocumentsEmail,
    BulkSendDocumentsEmails,
    BulkSendDocumentRequestEmails,
    BulkSendBookingConfirmationEmails
  };
}
